import { lazy } from 'react';

export const LocationsPage = lazy(() => import('./LocationsPage'));
